import React from "react";
import { Col, Row } from "antd";
import SetupEntityCard from "../components/SetupEntityCard";
import ActivityLogCard from "../components/ActivityLogCard";
import CommentsCard from "../components/CommentsCard";

// DetailsPage mirrors Payroll's Policy Details tab layout
// Props:
// - entity: selected entity object (from EntityDetailView)
// - entityId: selected entity id (string)
// - setupOptions: array of setup sections (optional; SetupEntityCard uses DummyData internally for now)
// - auditLogs: array for activity log (optional)
const DetailsPage = ({
  entity,
  entityId,
  setupOptions,
  auditLogs = [],
  comments = [],
}) => {
  return (
    <Row gutter={[16, 16]}>
      <Col span={16}>
        <SetupEntityCard entityData={entity} entityId={entityId} />
      </Col>
      <Col span={8}>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <ActivityLogCard entityId={entityId} auditLogs={auditLogs} />
          </Col>
          <Col span={24}>
            <CommentsCard entityId={entityId} comments={comments} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default DetailsPage;
